import {
  useState, useEffect, // , useCallback, useMemo, useRef,
} from 'react';
// import { useHistory } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { message } from 'antd';
// import { useTranslation } from 'react-i18next';

// import userApi from '@api/userApi';
// import usersActions from '@state/user/actions';

function useMetricsDetail() {

  // const dispatch = useDispatch();
  // const history = useHistory();
  // const { t } = useTranslation();
  // const abortController = useRef(null);

  const [loading, setLoading] = useState(true);

  const dataSource = [
    {
      key: '1',
      titulo1: 'Valor',
      titulo2: 'Valor',
      titulo3: 'Valor',
    },
    {
      key: '2',
      titulo1: 'Valor',
      titulo2: 'Valor',
      titulo3: 'Valor',
    },
  ];

  const columns = [
    {
      title: 'Titulo',
      dataIndex: 'titulo1',
      key: 'titulo1',
    },
    {
      title: 'Titulo',
      dataIndex: 'titulo2',
      key: 'titulo2',
    },
    {
      title: 'Titulo',
      dataIndex: 'titulo3',
      key: 'titulo3',
    },
  ];

  const optionsGraphG1 = {
    chart: {
      height: 300,
      type: 'donut',
    },
    responsive: [{
      breakpoint: 380,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: 'bottom',
        },
      },
    }],
  };

  const seriesGraphG1 = [44, 55];

  const optionsGraphG2 = {
    chart: {
      height: 350,
      type: 'area',
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      type: 'datetime',
      categories: ['2018-09-19T00:00:00.000Z', '2018-09-19T01:30:00.000Z', '2018-09-19T02:30:00.000Z', '2018-09-19T03:30:00.000Z', '2018-09-19T04:30:00.000Z', '2018-09-19T05:30:00.000Z', '2018-09-19T06:30:00.000Z'],
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm',
      },
    },
  };

  const seriesGraphG2 = [{
    name: 'series1',
    data: [31, 40, 28, 51, 42, 109, 100],
  }, {
    name: 'series2',
    data: [11, 32, 45, 32, 34, 52, 41],
  }];

  useEffect(() => { // componentDidMount

    setLoading(false);

  }, []);

  return {
    loading,
    dataSource,
    columns,
    optionsGraphG1,
    seriesGraphG1,
    optionsGraphG2,
    seriesGraphG2,
  };

}

export default useMetricsDetail;
